import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Button from "../../../components/button";
import IconClose from "../../../components/icons/close";
import Localization from "../../../localization";
import Image from "../../../components/image";
import ModalCancel from "../../../components/modalCancel";
import { deleteUserMe } from "../../../redux/actions/me";
import { getMe } from "../../../redux/selectors/me";
import { getUrl } from "../../../utils/helper";
import { DateTime } from "luxon";

class Profile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            deleteModalVisible: false,
        };
    }

    _onClickDelete = () => {
        this.setState({
            deleteModalVisible: true,
        });
    };

    _onDelete = () => {
        this.props.deleteUserMe();
    };

    render() {
        const { user, locale } = this.props;
        const { deleteModalVisible } = this.state;

        return (
            <div>
                <div className="flex flex-col mb-16">
                    <div className="flex relative">
                        <p className="text-30 font-judge font-bold flex-1">
                            {Localization[locale].account.profile}
                        </p>
                        <div className="xl:hidden absolute right-0 top-0">
                            <Button
                                icon={
                                    <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-white text-blue" />
                                }
                                to={getUrl("account")}
                                style={"w-50 xl:w-70"}
                            />
                        </div>
                        <div className="hidden xl:block absolute right-0 top-0">
                            <Button
                                to={getUrl("account/profile/edit")}
                                text={Localization[locale].account.edit}
                                textStyle={
                                    "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-white text-blue"
                                }
                                style="w-150 z-10"
                            />
                        </div>
                    </div>
                    <div className="grid xl:grid-cols-2 mt-40">
                        <div className="mb-26">
                            <p className="font-bold mb-6">
                                {Localization[locale].account.name}
                            </p>
                            <p>{user.name ? user.name : "-"}</p>
                        </div>
                        <div className="mb-26 xl:mb-0">
                            <p className="font-bold mb-6">
                                {Localization[locale].account.email}
                            </p>
                            <p>{user.email ? user.email : "-"}</p>
                        </div>
                        <div className="mb-26">
                            <p className="font-bold mb-6">
                                {Localization[locale].account.type}
                            </p>
                            <p>{user.type ? user.type : "-"}</p>
                        </div>
                        <div className="mb-26 xl:mb-0">
                            <p className="font-bold mb-6">
                                {Localization[locale].account.password}
                            </p>
                            <p>**************</p>
                        </div>
                        <div className="mb-26">
                            <p className="font-bold mb-6">
                                {Localization[locale].account.gender}
                            </p>
                            <p>{user.gender ? user.gender : "-"}</p>
                        </div>
                        <div className="mb-26 xl:mb-0">
                            <p className="font-bold mb-6">
                                {Localization[locale].account.birthday}
                            </p>
                            <p>
                                {user.birthday
                                    ? DateTime.fromISO(
                                          user.birthday
                                      ).toLocaleString(DateTime.DATE_MED)
                                    : "-"}
                            </p>
                        </div>
                        <div className="mb-26">
                            <p className="font-bold mb-6">
                                {Localization[locale].account.nationality}
                            </p>
                            <p>{user.nationality ? user.nationality : "-"}</p>
                        </div>
                        <div className="mb-26 xl:mb-0">
                            <p className="font-bold mb-6">
                                {Localization[locale].account.address}
                            </p>
                            <p>{user.address ? user.address : "-"}</p>
                        </div>
                        <div className="mb-26 xl:mb-0">
                            <p className="font-bold mb-6">
                                {Localization[locale].account.vat}
                            </p>
                            <p>{user.nif ? user.nif : "-"}</p>
                        </div>
                        <div className="mb-26 xl:mb-0">
                            <p className="font-bold mb-6">
                                {Localization[locale].account.phone}
                            </p>
                            <p>{user.phone ? user.phone : "-"}</p>
                        </div>
                    </div>
                    <div className="grid xl:grid-cols-2 xl:mt-26">
                        <div className="mb-26 xl:mb-0">
                            <p className="font-bold mb-6">
                                {Localization[locale].account.website}
                            </p>
                            <p>{user.website_url ? user.website_url : "-"}</p>
                        </div>
                        <div>
                            <p className="font-bold mb-6">
                                {Localization[locale].account.biography}
                            </p>
                            <p>{user.bio ? user.bio : "-"}</p>
                        </div>
                    </div>
                    {user.photo && (
                        <div className="mt-26">
                            <p className="font-bold mb-6">
                                {Localization[locale].account.photo}
                            </p>
                            <div className="w-200">
                                <Image
                                    alt={user.name}
                                    url={user.photo.url}
                                    aspectRatio="aspect-ratio-square"
                                    width={196}
                                />
                            </div>
                        </div>
                    )}
                    <div className="mt-26">
                        <button
                            type="button"
                            className="text-red"
                            onClick={this._onClickDelete}
                        >
                            {Localization[locale].account.delete_account}
                        </button>
                    </div>
                </div>
                <div className="fixed bg-grey p-16 bottom-0 left-0 right-0 xl:hidden">
                    <Button
                        to={getUrl("account/profile/edit")}
                        text={Localization[locale].account.edit}
                        textStyle={
                            "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-white text-blue"
                        }
                        wrapperStyle="px-15"
                    />
                </div>
                <ModalCancel
                    visible={deleteModalVisible}
                    data={true}
                    title={Localization[locale].account.delete_account}
                    text={Localization[locale].account.delete_account_text}
                    onClose={(cancel) => {
                        if (cancel) this._onDelete();

                        this.setState({
                            deleteModalVisible: false,
                        });
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    user: getMe(state),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        deleteUserMe
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
